module.exports = __webpack_public_path__ + "img/skill-5.2a0ffe9a.svg";